import InvoiceDetailContainer from "./InvoiceDetailContainer";
export default InvoiceDetailContainer;
